import { rm } from 'utils/resource';
import styles from './choices.scss';
import {
  getCategoryFilterFacet,
  getFilterPanels,
  getFilterPanelsWithoutFacet
} from 'components/Filter/selector';
import { NO_ELEMENT, withCurrentPage } from 'utils';
import { filterToggleCategory, filterToggleReset } from 'components/Filter/actions';
import { filterChanged } from 'views/ProductlistPage/actions';
import cn from 'classnames';
import { Choice } from 'components/Filter/themes/BGH/types/choice';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrencySymbol } from 'store/appShell/selector';
import {
  ChoiceFilter,
  getActiveChoices,
  isGroupChoice,
  ValueChoice
} from 'components/Filter/utils';

// filter choices not showing when not effecting the product list Jira: https://bygghemma-it.atlassian.net/browse/ECP-1598
interface ChoicesProps {
  containerClassName?: string;
  choiceClassName?: string;
}

export const Choices = ({ choiceClassName, containerClassName }: ChoicesProps) => {
  const reduxDispatch = useDispatch();
  const filterPanels = useSelector(withCurrentPage(getFilterPanels));
  const categoryFilterFacet = useSelector(withCurrentPage(getCategoryFilterFacet));
  const currencySymbol = useSelector(getCurrencySymbol);

  const filterPanelsWithoutFacet = getFilterPanelsWithoutFacet(filterPanels, categoryFilterFacet);
  const choices = getActiveChoices({ filterPanels: filterPanelsWithoutFacet, currencySymbol });

  const toggleCategory = (choiceFilter: ChoiceFilter) => () => {
    reduxDispatch(filterToggleCategory({ facet: choiceFilter.name, ...choiceFilter }));
    reduxDispatch(filterChanged());
  };

  const onReset = () => {
    reduxDispatch(filterToggleReset());
    reduxDispatch(filterChanged());
  };

  if (!Array.isArray(choices) || choices.length <= 0) {
    return NO_ELEMENT;
  }

  return (
    <div className={cn(styles.choices, containerClassName)}>
      <Choice
        className={cn(styles.choicesButton, choiceClassName)}
        iconClassName={styles.choicesIcon}
        onClick={onReset}
      >
        {rm('filter_choices_clear_button')}
      </Choice>

      {choices.map(choice => (
        <Choice
          className={cn(styles.choicesButton, choiceClassName)}
          iconClassName={styles.choicesIcon}
          key={choice.name}
          onClick={toggleCategory(choice)}
        >
          <span>
            {choice.prefix && `${choice.prefix}: `}
            {isGroupChoice(choice)
              ? (choice.facets.filter(f => !isGroupChoice(f)) as ValueChoice[])
                  .map(f => f.displayName)
                  .join(', ')
              : choice.displayName}
          </span>
        </Choice>
      ))}
    </div>
  );
};
